export const calendarDt = {
    title: {
        gap: '0.375rem',
        fontWeight: '600',
    },
    selectMonth: {
        padding: '0.125rem 0.25rem',
        borderRadius: '0.5rem',
        color: '#344054',
        hoverBackground: '#F2F4F7',
        hoverColor: '#101828',
    },
    selectYear: {
        padding: '0.125rem 0.25rem',
        borderRadius: '0.5rem',
        color: '#344054',
        hoverBackground: '#F2F4F7',
        hoverColor: '#101828',
    },
    weekDay: {
        fontWeight: '500',
        color: '#98A2B3',
    },
    date: {
        padding: '0.125rem',
        borderRadius: '999px',
        color: '#344054',
        hoverBackground: '#F2F4F7',
        hoverColor: '#101828',
        selectedBackground: '#D0D5DD',
        selectedColor: '#344054',
        rangeSelectedBackground: '#D0D5DD',
        rangeSelectedColor: '#344054',
        focusRing: {
            width: '0',
            style: 'solid',
            color: 'transparent',
            offset: '0',
            shadow: 'none',
        },
    },
    today: {
        background: 'transparent',
        color: '#344054',
    },
};

export const calendarPt = {
    weekDay: {
        style: {
            fontSize: '15px',
        },
    },

    day: ({ context }: { context?: { today?: boolean } }) => ({
        style: {
            fontSize: '15px',
            fontWeight: '400',
            borderColor: context?.today ? '#FC7C19' : undefined,
        },
    }),
};
